import { useMemo } from "react";

import renderCashOutUsingPaymentEntity from "../Modals/Funding Instruments/cash-out-using-payment-entity";

import { useModalContext } from "../../Contexts/ModalContext";

import { useActivities, useStakeDebit } from "../../CustomHooks/Queries";

import { formatCurrency, isSVDApproved } from "../../Utils/helpers";

export default function ProfileBar() {
  const { isLoading: isLoadingActivities, data: activitiesData } = useActivities();

  const modalContext = useModalContext();

  const { data: stakeDebit } = useStakeDebit();

  const IsSVDApproved = useMemo(() => {
    return isSVDApproved(stakeDebit?.data);
  }, [stakeDebit?.data]);

  const walletAmount = useMemo(() => {
    if (isLoadingActivities) return 0;
    return activitiesData?.data?.data?.currentBalance ?? 0;
  }, [isLoadingActivities, activitiesData]);

  return (
    <div className="profile-bar">
    </div>
  );
}
